import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import IPathParams from '../interfaces/IPathParams';
import { blankChallenge, IChallenge } from '../interfaces/IChallenge';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import tokenAtom from '../atoms/tokenAtom';
import { getChallenge } from '../persistence/ChallengePersistence';
import { NotificationType } from '../interfaces/INotification';
import notificationAtom from '../atoms/notificationAtom';

const Challenge: FC = () => {
  const { id } = useParams<IPathParams>();
  const [challenge, setChallenge] = useState<IChallenge>(blankChallenge);
  const token = useRecoilValue(tokenAtom);
  const setNotification = useSetRecoilState(notificationAtom);

  useEffect(() => {
    getChallenge(id, token).then(fetched => {
      setChallenge(fetched);
    }).catch(err => {
      setNotification({
        type: NotificationType.FAILURE,
        isOpen: true,
        title: 'Error getting Hero',
        message: err.message
      });
    });
  }, [id, token, setChallenge, setNotification]);

  return (
    <div className="challenge-page">
      <h2>{challenge.name}</h2>
      <h3>Setup:</h3>
      <p>{challenge.setup}</p>
      <h3>Collection:</h3>
      <p>{challenge.collection}</p>
    </div>
  );
}

export default Challenge;
